import { useState } from 'react'

import { getEmbedUrlForId } from './videoTouch'

interface Props {
  videoTouchId: string
}
export function VideoTouchIframe({ videoTouchId }: Props) {
  const [iframeLoaded, setIframeLoaded] = useState(false)

  const handleLoadIframe = () => {
    setIframeLoaded(true)
  }
  const origin = typeof window === 'undefined' ? '' : window.location.origin

  return (
    <div className="faq-answer-video-touch">
      <iframe
        className={iframeLoaded ? '' : 'hidden'}
        onLoad={handleLoadIframe}
        src={getEmbedUrlForId(videoTouchId)}
        title="videoTouch video player"
        allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      />
    </div>
  )
}
